import {
  apiProductDetailsComplianceData,
  apiGetComplianceTypes,
  apiGetComplianceCustomOptions,
} from 'api';
import { getMomentDate } from 'util/date';

export const callComplianceDataAction = async ({ key, action, id, data, entity = 'products' }) => {
  try {
    const res = await apiProductDetailsComplianceData({
      key,
      action,
      id,
      data,
      entity,
    });
    if ([200, 201].includes(res?.data?.code)) {
      return { success: true, data: res.data };
    }
    return { success: false, error: res };
  } catch (error) {
    return { success: false, error };
  }
};
export const getComplianceTypes = async () => {
  try {
    const res = await apiGetComplianceTypes({
      pageNo: 1,
      pageSize: 9999,
    });
    if ([200].includes(res?.data?.code)) {
      return { success: true, data: res.data.data?.list || [] };
    }
    return { success: false, error: {} };
  } catch (error) {
    return { success: false, error };
  }
};
export const getComplianceCustomOptions = async (type) => {
  try {
    const res = await apiGetComplianceCustomOptions({
      pageNo: 1,
      pageSize: 9999,
      type,
    });
    if ([200].includes(res?.data?.code)) {
      return { success: true, data: res.data.data?.list || [] };
    }
    return { success: false, error: {} };
  } catch (error) {
    return { success: false, error };
  }
};

export const getComplianceDataBadgeCount = async (productId, cb, entity = 'products') => {
  const today = getMomentDate('', true).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  const testDataRes = await callComplianceDataAction({
    key: 'test-data',
    action: 'get',
    id: productId,
    data: {},
    entity,
  });
  const testData = testDataRes?.data?.data || [];
  const certificateDataRes = await callComplianceDataAction({
    key: 'certificate-data',
    action: 'get',
    id: productId,
    data: {},
    entity,
  });
  const certificateData = certificateDataRes?.data?.data || [];
  const otherDataRes = await callComplianceDataAction({
    key: 'other-data',
    action: 'get',
    id: productId,
    data: {},
    entity,
  });
  const otherData = otherDataRes?.data?.data || [];
  const expiredComplianceData = [...testData, ...certificateData, ...otherData].filter((obj) => {
    if (!obj.expiryDate) return false;
    const tMomentVal = getMomentDate(obj.expiryDate);
    return (
      tMomentVal
        .clone()
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .isBefore(today) && obj.status !== 'archived'
    );
  });
  if (cb) cb(expiredComplianceData.length || 0, [...testData, ...certificateData, ...otherData]);
};
